import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="8" fill="#F4F5F7"/>
<rect width="32" height="32" rx="8" fill="#00BDF4"/>
<path d="M19.1771 16.0182H9.14294" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.7374 13.5884L19.1774 16.0184L16.7374 18.4484" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M13.087 12.1576V11.3801C13.087 9.68423 14.4612 8.31006 16.1579 8.31006H20.2279C21.9195 8.31006 23.2904 9.68089 23.2904 11.3726V20.6559C23.2904 22.3517 21.9154 23.7267 20.2195 23.7267H16.1487C14.4579 23.7267 13.087 22.3551 13.087 20.6642V19.8792" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

